import {
  LOAD_AVAL_QUOTE_INFO,
  CREATE_AVAL_BURO_FORM,
  SUBMIT_AVAL_BURO_FORM,
  CLEAR_AVAL_TOKEN
} from '../actions/avalBuroFormActions';

const initialState = {
  quoteInformation: null,
  tokenValidationStatus: null,
  formId: null,
  formResult: null
};

const avalBuroFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_AVAL_QUOTE_INFO.start: {
      return { ...state, tokenValidationStatus: 'pending' };
    }
    case LOAD_AVAL_QUOTE_INFO.success: {
      return {
        ...state,
        tokenValidationStatus: 'success',
        quoteInformation: action.payload
      };
    }
    case LOAD_AVAL_QUOTE_INFO.failure: {
      return {
        ...state,
        tokenValidationStatus: action.payload || '401'
      };
    }
    case CREATE_AVAL_BURO_FORM.success: {
      return { ...state, formId: action.payload };
    }
    case SUBMIT_AVAL_BURO_FORM.success: {
      return { ...state, formResult: action.payload };
    }
    case CLEAR_AVAL_TOKEN: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default avalBuroFormReducer;
